// Pass an object of components to be injected into the MDX provider
const markdownComponents = {};

export default markdownComponents;
